import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

const INVALID_TOTAL_LIVNG_AREA_ERROR_KEY = 'invalidTotalLivingArea';
const MAX_AREA = 99999;
const MIN_AREA = 100;

export class RoomByRoomCommon {
    static trimmedRequired: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
        const value = typeof control.value === 'string' ? control.value.trim() : '';
        return value.length > 0 ? null : { required: true };
    };

    static trimValue(control: AbstractControl): void {
        if (typeof control.value === 'string') {
            control.setValue(control.value.trim());
        }
    }

    static toNumber(value: unknown): number | null {
        if (value === null || value === undefined) {
            return null;
        }

        if (typeof value === 'string' && value.trim() === '') {
            return null;
        }

        const normalized = typeof value === 'string' ? Number(value.trim()) : Number(value);

        return Number.isFinite(normalized) ? normalized : null;
    }

    static requiredValidTotalLivingArea(control: AbstractControl): ValidationErrors | null {
        if (Validators.required(control)) {
            return { required: true };
        }

        const value = RoomByRoomCommon.toNumber(control.value);

        if (value === null || value < MIN_AREA || value > MAX_AREA) {
            return { [INVALID_TOTAL_LIVNG_AREA_ERROR_KEY]: true };
        }

        return null;
    }
}
